import type { PartSvgProps } from './types'

export default function AkSideRailSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  width = 80,
  height = 60
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 80 60" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="10" width="72" height="44" rx="3"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* rail cut top */}
      <rect x="6" y="10" width="68" height="10" fill="#0A0D14" />
      {/* screw holes */}
      <circle cx="22" cy="38" r="4" fill={stroke} />
      <circle cx="58" cy="38" r="4" fill={stroke} />
    </svg>
  )
}
